/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ActionInstance} from "../../../../models/action-instance";
import {InstanceData} from "../../../../models/instance-data";
import {Dialog} from "../../../../models/dialog";
import {Group} from "../../../../models/group";
import {OnInit, Component, Input} from "@angular/core";
import {ActivatedRoute} from "@angular/router";

const PROP_TO_GROUP = "to_group";

@Component({
  selector: 'app-dialog-recipients',
  templateUrl: './dialog-recipients.component.html'
})
export class DialogRecipientsComponent implements OnInit {

  @Input()
  set dialog(dialog: Dialog) {
    this.mDialog = dialog;
    //this.reset(); // KHT 08/16/2021 - commented out call to reset() as it is no longer needed after Angular update
  }
  
  @Input()
  mAction: ActionInstance;
    
  //Dialog which is being edited/displayed...
  mDialog: Dialog;

  //All Roles known to the system, retrieved from the resolver
  mRoles: Group[];

  //Roles being displayed to the User depending on their search value
  mDisplayedRoles: Group[] = [];

  mRoleSearchValue: string;


  constructor(
    private mRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.mRoute.data.subscribe((data: {roles: Group[]}) => {
      this.mRoles = data.roles == null ? [] : data.roles;
      this.refreshDisplayedRoles();
      this.syncRolesWithData();
    });
  }

  private reset(): void {
    this.mRoleSearchValue = null;
    this.refreshDisplayedRoles();
  }

  refreshDisplayedRoles(): void {
    console.log("_____refreshDisplayedRoles");
    const roles: Group[] = [];
    const searchValue = this.mRoleSearchValue;
    if (searchValue == null || searchValue.length == 0) {
      roles.push(...this.mRoles);
    } else {
      roles.push(...this.mRoles.filter(role => role.name.indexOf(searchValue) > -1));
    }
    this.mDisplayedRoles = roles;
  }

  isRoleSelected(role: Group): boolean {
      const roleData = this.mAction.data.find(d => d.value == String(role.id) && d.property.property == PROP_TO_GROUP);
      if (roleData != null) {
        roleData.object_value = roleData.value;
        return true;
      }
      else {
        return false;
      }   
   
    return this.mAction.data.findIndex(d => d.value == String(role.id) && d.property.property == PROP_TO_GROUP) > -1;
  }

  selectRole(role: Group, select: boolean): void {
    if (select) {
      this.addRecipientGroup(role);
    }
    else {
      this.removeRecipientGroup(role);
    }
  }

  isAllDisplayedRolesSelected(): boolean {
    return this.mDisplayedRoles.find(role => !this.isRoleSelected(role)) == null;
  }

  setAllDisplayedRolesSelected(selected: boolean): void {
    this.mDisplayedRoles.forEach(role => this.selectRole(role, selected));
  }

  private addRecipientGroup(role: Group): void {
    const newData = new InstanceData();
    newData.property = this.mAction.action.properties.find(p => p.property == PROP_TO_GROUP);
    newData.value = String(role.id);
    this.mAction.data == null ? this.mAction.data = [ newData ] : this.mAction.data.push(newData);
  }

  private removeRecipientGroup(role: Group): void {
    const roleId = String(role.id);
    const index = this.mAction.data != null ? this.mAction.data.findIndex(d => d.value == roleId && d.property.property == PROP_TO_GROUP) : -1;
    
    if (index > -1) {
      this.mAction.data.splice(index, 1);
    }

    this.mAction.data.forEach(
        datum => {
            if (datum.property.property == PROP_TO_GROUP) {
                console.log("value -> " + datum.value);
        }
    });
  }

  private syncRolesWithData(): void {
    if (this.mAction != null && this.mAction.data != null) {
        this.mAction.data.forEach(
            datum => {
                if (datum.property.property == PROP_TO_GROUP) {
                    const group = new Group();
                    group.id  = Number(datum.value);
                    this.mDisplayedRoles.push(group);
                }
            });
        }
    }

}
